import React from 'react'

class ShowStaff extends React.Component {
	constructor(props){
		super(props)

		this.state = {
			items: this.props.show_staff || []
		}
	}

	handleAddNewItem(){
		// Render a new form.
		const items = this.state.items

		// Generate a new id.
		const id = items.reduce( (id, item) => {
			if(item.id >= id){
				id = parseInt(item.id, 10) + 1
			}
			return id
		}, 0)

		// Add the new item to the list.
		items.push({
			id: id,
			title: '', // 'Director', 'Costumes'
			name: ''
		})

		// Save it to state.
		this.setState({ items })
	}

	handleItemRemove(id){
		// Filter the list by the item selected to remove.
		// eslint-disable-next-line
		const items = this.state.items.filter( item => item.id != id )

		// Save the updated array to state.
		this.setState({ 
			items: items,
		})
	}

	handleItemUpdate(form){
		// Generate a new list updating the selected item.
		var items = this.state.items.map( item => {
			// eslint-disable-next-line
			if(item.id == form.getAttribute('data-id')){
				return {...item,
					title: encodeURIComponent(form.querySelector('.title').value),
					name: encodeURIComponent(form.querySelector('.name').value)
				}
			} else {
				return item
			}
		})

		this.setState({ 
			items: items
		})
	}

	render() {
		return (
			<section className="show_staff">
				<h3>Show Staff</h3>
				{this.state.items.map( (item, i) => { 
					return (
						<div key={i} data-id={item.id} className="staff_container" onChange={ (e) => {this.handleItemUpdate(e.target.closest('div'))} }>
								<input type="text" defaultValue={item.title ? decodeURIComponent(item.title) : ''} placeholder="Title" className="title" />
								<input type="text" defaultValue={item.name ? decodeURIComponent(item.name) : ''} placeholder="Name" className="name"  />
								<button className="delete" onClick={ (e) => {this.handleItemRemove(item.id)} }>Delete</button>
						</div>
					)
				})}
				<button className="add button" onClick={this.handleAddNewItem.bind(this)}>Add Staff Member</button>
			</section>
		)
	}
}

export default ShowStaff


// WEBPACK FOOTER //
// ./src/components/show_staff.js